import { CognitoUserPool } from "amazon-cognito-identity-js";
import { getConfig } from "src/config/Config";

export function getCognitoUserPool() {
  const config = getConfig();

  return new CognitoUserPool({
    UserPoolId: config.COGNITO_USER_POOL_ID,
    ClientId: config.COGNITO_CLIENT_ID
  });
}
